import React from 'react';
import { Link } from 'react-router-dom';

const Navbar: React.FC = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm sticky-top">
      <div className="container">
        <Link className="navbar-brand d-flex align-items-center" to="/">
          <img src="/logo.svg" alt="Creative Cat Logo" width="40" className="me-2" />
          <span className="fw-bold fs-4">Kocúr.ai</span>
        </Link>
        {/*<button */}
        {/*  className="navbar-toggler" */}
        {/*  type="button" */}
        {/*  data-bs-toggle="collapse" */}
        {/*  data-bs-target="#navbarNav" */}
        {/*  aria-controls="navbarNav" */}
        {/*  aria-expanded="false" */}
        {/*  aria-label="Toggle navigation"*/}
        {/*>*/}
        {/*  <span className="navbar-toggler-icon"></span>*/}
        {/*</button>*/}
        {/*<div className="collapse navbar-collapse" id="navbarNav">*/}
        {/*  <ul className="navbar-nav ms-auto">*/}
        {/*    <li className="nav-item">*/}
        {/*      <Link className="nav-link" to="/">Home</Link>*/}
        {/*    </li>*/}
        {/*    <li className="nav-item">*/}
        {/*      <Link className="nav-link" to="/terms">Terms</Link>*/}
        {/*    </li>*/}
        {/*  </ul>*/}
        {/*</div>*/}
      </div>
    </nav>
  );
};

export default Navbar;
